import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import NavTabs from "../../../../../../components/Tabs/NavTabs";
import EditingTables from "./editingTables";
import { useGeneralContext } from "../GeneralContext";
import MaterialRecords from "../../../../MaterialRecords";

export default function ClientDataEditingPage({ tab = "structural" }) {
  const { getAllTabelsFromDB } = useGeneralContext();
  const [allTables, setAllTables] = useState([]);

  const filteredTables = useMemo(() => {
    if (!allTables) return [];
    return Object.keys(allTables).sort();
  }, [allTables]);

  useEffect(() => {
    async function fetchTables() {
      const tables = await getAllTabelsFromDB(tab);
      setAllTables(tables);
    }
    fetchTables();
  }, [getAllTabelsFromDB, tab]);

  const mainTabs = useMemo(
    () => [
      {
        label: "Piping Tables",
        panel: (
          <Box sx={{ width: "100%" }}>
            <NavTabs
              navLabel="piping-editing-tabs"
              tabs={[
                {
                  label: "Spec",
                  panel: (
                    <EditingTables
                      title="Piping Spec"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("spec") ||
                        name.toLowerCase().includes("pipe") ||
                        name.toLowerCase().includes("piping")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
                {
                  label: "Estimation",
                  panel: (
                    <EditingTables
                      title="Piping Estimation"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("est") ||
                        name.toLowerCase().includes("pipe") ||
                        name.toLowerCase().includes("piping")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
              ]}
            />
          </Box>
        ),
      },
      {
        label: "Structure Tables",
        panel: (
          <Box sx={{ width: "100%" }}>
            <NavTabs
              navLabel="structure-editing-tabs"
              tabs={[
                {
                  label: "Spec",
                  panel: (
                    <EditingTables
                      title="Structure Spec"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("spec")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
                {
                  label: "Estimation",
                  panel: (
                    <EditingTables
                      title="Structure Estimation"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("est")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
                {
                  label: "Validation",
                  panel: (
                    <EditingTables
                      title="Structure Validation"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("valid")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
              ]}
            />
          </Box>
        ),
      },
      {
        label: "Pressure Vessel Tables",
        panel: (
          <Box sx={{ width: "100%" }}>
            <NavTabs
              navLabel="pv-editing-tabs"
              tabs={[
                {
                  label: "Input Data",
                  panel: (
                    <EditingTables
                      title="Pressure Vessel Input Data"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("input")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
                {
                  label: "Estimation",
                  panel: (
                    <EditingTables
                      title="Pressure Vessel Estimation"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("est")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
                {
                  label: "Calculation",
                  panel: (
                    <EditingTables
                      title="Pressure Vessel Calculation"
                      tableOptions={filteredTables.filter((name) =>
                        name.toLowerCase().includes("calc")
                      )}
                      dbTab={tab}
                      tableApi={{ getItems: async () => [] }}
                      initialTable={filteredTables[0]}
                    />
                  ),
                },
              ]}
            />
          </Box>
        ),
      },
      {
        label: "Material",
        panel: <MaterialRecords />,
      },
    ],
    [filteredTables, tab]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        pt: 2,
        width: "100%",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <NavTabs
          navLabel="editing-tables-main"
          tabs={mainTabs}
          tabProps={{ variant: "scrollable", scrollButtons: "auto" }}
        />
      </Box>
    </Box>
  );
}
